import React, {Component} from 'react'
import {Image, Icon, Input, Button, Grid, Popup, Table, TableBody, TableRow, TableCell} from 'semantic-ui-react'
import Utils from "../../../modules/utils"

class ErpCompanyName extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      savedName: null,
      editing: false
    }
  }

  edit = () => {
    this.setState({editing: true})
  }

  stopEdit = () => {
    this.setState({editing: false})
  }

  save = () => {
    const {account} = this.props

    let savedName = document.getElementById('new-company-name').value

    let data = {
      contact_id: account.id,
      erp_company_name: savedName
    }

    Utils.post('update_company_name', data, (err, res) =>
    {
      if (err) {
        alert('There was an error when trying to update the company name.')
      } else {
        this.setState({savedName})
        this.stopEdit()
      }
    })
  }

  onChangeInput = () => {
    clearTimeout(window.setTimeoutNormalize)
    window.setTimeoutNormalize = setTimeout(this.normalize, 500)
  }

  normalize() {
    let value = document.getElementById('new-company-name').value

    value = value.toUpperCase().replace(/\p{Space}/g,' ').replace(/  +/g, ' ').trim()

    document.getElementById('new-company-name').value = value
  }

  render() {
    const {account} = this.props
    const {editing, savedName} = this.state

    let defaultValue = savedName == null ? account.company.name : savedName

    const SaveConfirmTrigger = <Icon name='check' style={{color: 'rgb(213,168,60)', cursor: 'pointer'}} />

    const SaveConfirm = (
      <Popup wide trigger={SaveConfirmTrigger} on='click'>
        <Button color='blue' content='Confirm save' fluid onClick={this.save}/>
      </Popup>
    )

    return (
      <div style={{border: '1px solid rgb(238,238,238)', padding: '25px', borderRadius: '10px'}}>

        <Table basic='very'>
          <TableBody>
            <TableRow>
              <TableCell style={{width: '40px'}}><Icon circular size='large' name="building outline"/></TableCell>
              <TableCell style={{color: 'rgb(200, 200, 200)', fontWeight: 'bold', width: '104px'}}>Company</TableCell>
              <TableCell>
                {
                  editing
                  ?
                  <React.Fragment>
                    <Input id="new-company-name" style={{width: '85%', fontSize: '20px'}} placeholder='Company name' defaultValue={defaultValue} onChange={this.onChangeInput}/>
                    &nbsp;&nbsp;
                    {SaveConfirm}
                    &nbsp;&nbsp;
                    <Popup content='Cancel company name edit' trigger={<Icon name='close' style={{color: 'red', cursor: 'pointer'}} onClick={this.stopEdit}/>} />
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <div style={{display: 'none'}}>{defaultValue}</div>
                    <Input defaultValue={defaultValue} placeholder='(missing)' style={{width: '85%', fontSize: '20px'}} disabled/>
                    &nbsp;&nbsp;
                    <Popup content='Edit company' trigger={<Icon name='pencil' style={{color: 'rgb(213,168,60)', cursor: 'pointer'}} onClick={this.edit}/>} />
                  </React.Fragment>
                }
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{width: '40px'}}><Icon circular size='large' name="user outline"/></TableCell>
              <TableCell style={{color: 'rgb(200, 200, 200)', fontWeight: 'bold', width: '104px'}}>Buyer</TableCell>
              <TableCell><b style={{fontSize: '20px', marginLeft: '20px'}}>{account.primaryContact == null ? 'Missing primary contact' : account.primaryContact.name}</b></TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{width: '40px'}}><Icon circular size='large' name="hashtag"/></TableCell>
              <TableCell style={{color: 'rgb(200, 200, 200)', fontWeight: 'bold', width: '104px'}}>Contact ID</TableCell>
              <TableCell><b style={{fontSize: '20px', marginLeft: '20px'}}>{account.id}</b></TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{width: '40px'}}><Icon circular size='large' name="hashtag"/></TableCell>
              <TableCell style={{color: 'rgb(200, 200, 200)', fontWeight: 'bold', width: '104px'}}>Company ID</TableCell>
              <TableCell><b style={{fontSize: '20px', marginLeft: '20px'}}>{account.company.id}</b></TableCell>
            </TableRow>
          </TableBody>
        </Table>

      </div>
    )
  }
}

export default ErpCompanyName
